module.exports = __webpack_public_path__ + "img/app-llll.34c4cf67.webp";